module.exports = __webpack_public_path__ + "static/img/4.a5c17c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/4.png
// module id = zl1G
// module chunks = 0